import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";

/**
 * The trailing split column's first screen under iOS native navigation. Only
 * NativeRootController opens it, as the root of each pane tab's trailing stack.
 */
export const paneRoutes: RouteRender[] = [
  lazyView(
    routes.panes.trailingRoot,
    () => import("./pane-trailing-root").then((m) => ({ default: m.PaneTrailingRootPage })),
    "",
  ),
];
